import { exportModules } from '@/assets/js/__utils__/file';
// console.log('minxin')
let requireFiles = require.context('@/config/minxin', true, /\.js$/);
// console.log(requireFiles)
const modules = exportModules(requireFiles, false, true)

export default modules;
